import { useState, useEffect, useCallback } from "react";

export function useCurrentTime() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = useCallback((date: Date) => {
    return date.toLocaleTimeString("ru-RU", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }, []);

  const formatDate = useCallback((date: Date) => {
    const day = date.getDate();
    const month = date.toLocaleDateString("ru-RU", {
      month: "long",
    });
    const year = date.getFullYear();
    const dayOfWeek = date.toLocaleDateString("ru-RU", {
      weekday: "long",
    });
    return `${day} ${month} ${year}, ${dayOfWeek}`;
  }, []);

  return {
    currentTime,
    formatTime,
    formatDate,
  };
}
